import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M2.6 13h14.6l-5.3 5.3 1.4 1.4L21 12l-7.7-7.7-1.4 1.4 5.3 5.3H2.6v2z" }));
export {
  o as ReactComponent
};
